import { Chip, StateStack } from '@/components/ui'
import type { OpenOrderRow } from '../api/types'

type StatusVariant = 'success' | 'warning' | 'danger' | 'neutral'

const STATUS_VARIANT: Record<OpenOrderRow['status'], StatusVariant> = {
  'LATE': 'danger',
  'ON TIME': 'success',
  'CLOSED': 'neutral',
}

const COVERAGE_LABEL = {
  covered: 'COVERED',
  partial: 'PARTIAL',
  uncovered: 'UNCOVERED',
} as const

const COVERAGE_VARIANT: Record<
  Exclude<OpenOrderRow['coverage_status'], null>,
  StatusVariant
> = {
  covered: 'success',
  partial: 'warning',
  uncovered: 'danger',
}

/**
 * Composite State column — top chip is schedule (LATE / ON TIME / CLOSED),
 * bottom is procurement coverage (COVERED / PARTIAL / UNCOVERED).
 *
 * Paired with DataTable's `criticalRowPredicate` when both chips are
 * danger — the row gets a 2px red accent on the sticky-left cell (spec
 * §8.1 + 03b reference).
 */
export function StateCell({ row }: { row: OpenOrderRow }) {
  return (
    <StateStack>
      <Chip size="xs" variant={STATUS_VARIANT[row.status]} dot>
        {row.status}
      </Chip>
      {row.coverage_status ? (
        <Chip size="xs" variant={COVERAGE_VARIANT[row.coverage_status]} dot>
          {COVERAGE_LABEL[row.coverage_status]}
        </Chip>
      ) : null}
    </StateStack>
  )
}

/** Used as DataTable's `criticalRowPredicate`. */
// eslint-disable-next-line react-refresh/only-export-components
export function isCriticalOpenOrder(row: OpenOrderRow): boolean {
  return row.status === 'LATE' && row.coverage_status === 'uncovered'
}
